import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import $ from 'jquery';
import AdminNavigationBar from './projectmgmt/AdminNavigationBar';
import LiveExperience from './projectmgmt/LiveExperience';
import PatientAdmissionTabSettings from './projectmgmt/PatientAdmissionTabSettings';
import HealthSystemAdmin from './projectmgmt/HealthSystemAdmin';
import HospitalAdmin from './projectmgmt/HospitalAdmin';
import ServiceLineAdmin from './projectmgmt/ServiceLineAdmin';
import ProcedureAdmin from './projectmgmt/ProcedureAdmin';
import ReportsTabSettings from './projectmgmt/ReportsTabSettings';
import SurveyTabSettings from './projectmgmt/SurveyTabSettings';
import ViewForProcedureAdmin from './projectmgmt/ViewForProcedureAdminTabSettings';
import ViewForPhysicianTabSettings from './projectmgmt/ViewForPhysicianTabSettings';
import AboutUsTabSettings from './projectmgmt/AboutUsTabSettings';
import AboutMeTabSettings from './projectmgmt/AboutMeTabSettings';
import ViewPatientReport from './projectmgmt/ViewPatientReport';
import JournalTabSettings from './projectmgmt/JournalTabSettings';
import SurveyContent from './projectmgmt/SurveyContent';
import JournalContent from './projectmgmt/JournalContent';
import ManageTabSettings from './projectmgmt/ManageTabSettings';
import ContentLibraryTreatmentTabSettings from './projectmgmt/ContentLibraryTreatmentTabSettings';
import ContentLibraryServiceLineTabSettings from './projectmgmt/ContentLibraryServiceLineTabSettings';
import AIAgentTabSettings from './projectmgmt/AIAgentTabSettings';
import Dashboard from './projectmgmt/Dashboard';
import VirtualAgentSkills from './projectmgmt/VirtualAgentSkills';
import SkillMetaData from './projectmgmt/SkillMetaData';
import JournalReminder from './projectmgmt/JournalReminder';
import MedicationResults from './projectmgmt/MedicationResults';
import PatientJournal from './projectmgmt/PatientJournal';
import PatientJournalResult from './projectmgmt/PatientJournalResult';
import PatientJournalStatus from './projectmgmt/PatientJournalStatus';
import PatientJournalResultStatus from './projectmgmt/PatientJournalResultStatus';
import PatientRiskStatus from './projectmgmt/PatientRiskStatus';
import PatientDashBoard from './projectmgmt/PatientDashBoard';
import PatientDashBoardTable from './projectmgmt/PatientDashBoardTable';
import ErrorBoundary from '../ErrorBoundary';
import PatientSurvey from './projectmgmt/PatientSurvey';
import PatientSuveryResult from './projectmgmt/PatientSuveryResult';
import RiskRule from './projectmgmt/RiskRuleForAdmission';
import RiskRuleForProcedure from './projectmgmt/RiskRuleForProcedure';
import JournalMilestone from './projectmgmt/JournalMilestone';
import SurveyMilestone from './projectmgmt/SurveyMilestone';
import SurveyReminder from './projectmgmt/SurveyReminder';
import TranslationManagementPage from './projectmgmt/TranslationManagementPage';

class LeftPanel extends Component {
  constructor() {
    super();
    this.state = {

      showStaff: false,
      showPhysicainRoleView: false
    }
  }
  componentDidMount() {
    var thisController = this;
    localStorage.setItem('SurveyResultsTab', "Show");
    const userDetails = localStorage.getItem("user_details");
    if (!userDetails) return;

    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
    if (userRole == 'PROCEDURE_ADMIN') {
      thisController.state.showStaff = true;
      thisController.setState(thisController.state);
    } else if (userRole == 'PHYSICIAN') {
      thisController.state.showPhysicainRoleView = true;
      thisController.setState(thisController.state);
    }

    var currentPath = window.location.href;

    var recordsPathExist = false;
    var recordsTabsPatterns = ['/hospital', '/service-line', '/procedure', '/staff', '/patient'];
    for (var i = 0; i < recordsTabsPatterns.length; i++) {
      if (currentPath.includes(recordsTabsPatterns[i]) == true) {
        recordsPathExist = true;
        break;
      }
    }

    // Check for translations path
    if (currentPath.includes('/projectmgmt/translations')) {
      $("#translations-tab").addClass('activemenu');
      recordsPathExist = false;
    }

    if (!this.menuSelectionHandlerDefined) {
      this.menuSelectionHandlerDefined = true;
      $("#admin,#report-tab,#live-experience-tab,#patient-admin,#about-me-tab,#about-us,#survey-tab,#contact-us,#journal-tab,#translations-tab,#patient-app-experience-tab")
        .on("click", function () {
          $("#admin,#report-tab,#live-experience-tab,#patient-admin,#about-me-tab,#about-us,#survey-tab,#contact-us,#journal-tab,#translations-tab,#patient-app-experience-tab")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu');

        });
    }


    var path = window.origin + "/my-jeeva/projectmgmt";
    var path1 = window.origin + "/my-jeeva/projectmgmt/";
    if (currentPath.includes('/projectmgmt/reports') || currentPath.includes('/projectmgmt/view-patient-survey')) {
      $("#report-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/survey-reminder') || currentPath.includes('/projectmgmt/survey-milestone')) {
      $("#survey-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/journal-reminder') || currentPath.includes('/projectmgmt/journal-milestone')) {
      $("#journal-tab").addClass('activemenu');
    } else if ((currentPath.includes('/projectmgmt/survey') || currentPath.includes('/projectmgmt/add-survey-question')) && !currentPath.includes('/projectmgmt/survey-reminder') && !currentPath.includes('/projectmgmt/survey-milestone')) {
      $("#survey-tab").addClass('activemenu');
    } else if ((currentPath.includes('/projectmgmt/journal') || currentPath.includes('/projectmgmt/add-journal-question')) && !currentPath.includes('/projectmgmt/journal-reminder') && !currentPath.includes('/projectmgmt/journal-milestone')) {
      $("#journal-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/ai-agent/patient-app')) {
      $("#patient-app-experience-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/ai-agent')) {
      $("#live-experience-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/patient-admission')) {
      $("#patient-admin").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/about')) {
      $("#about-us").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/about-me')) {
      $("#about-me-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/contact-us')) {
      $("#contact-us").addClass('activemenu');
    } else if (currentPath == path || currentPath == path1 || recordsPathExist) {
      $("#admin").addClass('activemenu');
    }
    this.currentPath = window.location.href;
    this.pathWatcher = setInterval(() => {
      if (window.location.href !== this.currentPath) {
        this.currentPath = window.location.href;
        $("#admin, #report-tab, #live-experience-tab, #patient-admin, #about-me-tab, #about-us, #survey-tab, #contact-us, #journal-tab, #patient-app-experience-tab")
          .removeClass('activemenu');
        this.markActiveTabByPath(window.location.href);
      }
    }, 300);
  }



  componentWillUnmount() {
    var thisController = this;
    clearInterval(thisController.pathWatcher);
  }

  markActiveTabByPath(currentPath) {
    if (currentPath.includes('/projectmgmt/translations')) {
      $("#translations-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/patient-admission')) {
      $("#patient-admin").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/reports') || currentPath.includes('/projectmgmt/view-patient-survey')) {
      $("#report-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/survey-reminder') || currentPath.includes('/projectmgmt/survey-milestone')) {
      $("#survey-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/journal-reminder') || currentPath.includes('/projectmgmt/journal-milestone')) {
      $("#journal-tab").addClass('activemenu');
    } else if ((currentPath.includes('/projectmgmt/survey') || currentPath.includes('/projectmgmt/add-survey-question')) && !currentPath.includes('/projectmgmt/survey-reminder') && !currentPath.includes('/projectmgmt/survey-milestone')) {
      $("#survey-tab").addClass('activemenu');
    } else if ((currentPath.includes('/projectmgmt/journal') || currentPath.includes('/projectmgmt/add-journal-question')) && !currentPath.includes('/projectmgmt/journal-reminder') && !currentPath.includes('/projectmgmt/journal-milestone')) {
      $("#journal-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/ai-agent/patient-app')) {
      $("#patient-app-experience-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/ai-agent')) {
      $("#live-experience-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/about-me')) {
      $("#about-me-tab").addClass('activemenu');
    } else if (currentPath.includes('/projectmgmt/about')) {
      $("#about-us").addClass('activemenu');
    } else {
      $("#admin").addClass('activemenu');
    }
  }


  render() {
    return (
      <ErrorBoundary>
        <Router basename={window.contextPath}>
          <div>
            <link rel="stylesheet" href="./assets/css/responsive.css" />
            <link rel="stylesheet" href="./assets/css/hamburger.css" />
            <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
            <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
            <link rel="stylesheet" href="./assets/css/adminlte.css" />
            <link rel="stylesheet" href="./assets/css/styles.css" />
            <link rel="stylesheet" href="./assets/css/custom-style.css" />
            <link rel="stylesheet" href="./plugins/iCheck/all.css" />
            <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
            <link href="assets/css/scrollbar.css" rel="stylesheet" />
            <div className="content-wrapper no-print">
              <div className="left-menu" style={{ marginTop: '0px', position: "absolute", height: "auto" }} >
                <ul id="floatMenu">
                  <Link to="/projectmgmt" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="admin" className="tabs" style={{ cursor: 'pointer' }}>
                      <i className="fa flaticon-ui" /><span>{this.state.showPhysicainRoleView ? "Engagements" : "Administration"}</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/patient-admission" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="patient-admin" className="tabs"
                      style={{
                        display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) ? 'none' : 'block',
                        cursor: 'pointer'
                      }}
                    >
                      <i className="fa flaticon-ui" /><span>{this.state.showPhysicainRoleView ? "Patients" : "Patient Enrollments"}</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/survey" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="survey-tab" className="tabs" style={{ cursor: 'pointer' }}>
                      <i className="fa flaticon-ui" /><span>Survey</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/journal" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="journal-tab" className="tabs" style={{ cursor: 'pointer' }}>
                      <i className="fa flaticon-ui" /><span>Journal</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/reports" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="report-tab" className="tabs" style={{ cursor: 'pointer' }}>
                      <i className="fa flaticon-ui" /><span>Dashboard</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/ai-agent" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="live-experience-tab" className="tabs"
                      style={{
                        display: (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.ADMIN) ? 'block' : 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <i className="fa flaticon-ui" /><span>AI Agent</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/ai-agent/patient-app" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="patient-app-experience-tab" className="tabs"
                      style={{
                        display: 'none',
                        cursor: 'pointer'
                      }}
                    >
                      <i className="fa flaticon-ui" /><span>Patient App Experience</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/about" style={{ cursor: 'pointer', textDecoration: 'none' }}>
                    <li component="div" id="about-us" className="tabs" style={{
                      display: ((window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PROCEDURE_ADMIN) && (window.SCOPE_VALUE.CURRENT != window.SCOPE_VALUE.ADMIN)) ? 'block' : 'none',
                      cursor: 'pointer'
                    }}>
                      <i className="fa flaticon-ui" />
                      <span style={{ display: ((window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.PROCEDURE_ADMIN) && (window.SCOPE_VALUE.CURRENT != window.SCOPE_VALUE.ADMIN)) ? 'block' : 'none' }}>About Us</span>
                    </li>
                  </Link>
                  <Link to="/projectmgmt/about" style={{
                    display: (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.PHYSICIAN) ? 'block' : 'none',
                    cursor: 'pointer',
                    textDecoration: 'none'
                  }}>
                    <li component="div" id="about-me-tab" className="tabs" style={{
                      display: (window.SCOPE_VALUE.CURRENT <= window.SCOPE_VALUE.PHYSICIAN) ? 'block' : 'none',
                      cursor: 'pointer'
                    }}>
                      <i className="fa flaticon-ui" />
                      <span>About Me</span>
                    </li>
                  </Link>

                </ul>
              </div>
            </div>
            <Switch>
              <Route path='/projectmgmt/dashboard' component={Dashboard}></Route>
              <Route path='/projectmgmt/treatment-content-library' component={ContentLibraryTreatmentTabSettings}></Route>
              <Route path='/projectmgmt/service-line-content-library' component={ContentLibraryServiceLineTabSettings}></Route>
              <Route path='/projectmgmt/manage-patient-data' component={ManageTabSettings}></Route>
              <Route path="/projectmgmt/add-journal-question" component={JournalContent}></Route>
              <Route path="/projectmgmt/add-survey-question" component={SurveyContent}></Route>
              <Route path="/projectmgmt/reports/episode" component={ViewPatientReport}></Route>
              <Route path='/projectmgmt/about' component={((window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) || (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HOSPITAL_ADMIN) || (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.SERVICELINE_ADMIN)) ? AboutUsTabSettings : AboutMeTabSettings}></Route>
              <Route path='/projectmgmt/view-patient-report' component={ViewPatientReport}></Route>
              <Route path='/projectmgmt/procedure-admin' component={ProcedureAdmin}></Route>
              <Route path='/projectmgmt/service-line-admin' component={ServiceLineAdmin}></Route>
              <Route path='/projectmgmt/hospital-admin' component={HospitalAdmin}></Route>
              <Route path='/projectmgmt/health-system-admin' component={HealthSystemAdmin}></Route>
              <Route path='/projectmgmt/virtual-agent-skills' component={VirtualAgentSkills}></Route>
              <Route path='/projectmgmt/skill-meta-data' component={SkillMetaData}></Route>
              <Route path="/projectmgmt/ai-agent" component={AIAgentTabSettings}></Route>
              <Route path="/projectmgmt/reports" component={ReportsTabSettings}></Route>
              <Route path="/projectmgmt/survey" component={SurveyTabSettings}></Route>
              <Route path="/projectmgmt/journal" component={JournalTabSettings}></Route>
              <Route path="/projectmgmt/translations" component={TranslationManagementPage}></Route>
              <Route path="/projectmgmt/journal-reminder" component={JournalReminder}></Route>
              <Route path="/projectmgmt/journal-milestone" component={JournalMilestone}></Route>
              <Route path="/projectmgmt/survey-milestone" component={SurveyMilestone}></Route>
              <Route path="/projectmgmt/survey-reminder" component={SurveyReminder}></Route>
              <Route path="/projectmgmt/view-patient-journal-status" component={PatientJournalStatus}></Route>
              <Route path="/projectmgmt/view-patient-journal-result-status" component={PatientJournalResultStatus}></Route>
              <Route path="/projectmgmt/view-patient-survey" component={PatientSurvey}></Route>
              <Route path="/projectmgmt/view-patient-survey-result" component={PatientSuveryResult}></Route>
              <Route path="/projectmgmt/medication-results" component={MedicationResults}></Route>
              <Route path="/projectmgmt/patient-admission" component={PatientAdmissionTabSettings}></Route>
              <Route path="/projectmgmt/procedure/risk-rule" component={RiskRuleForProcedure}></Route>

              <Route path="/projectmgmt" component={this.state.showPhysicainRoleView ? ViewForPhysicianTabSettings : AdminNavigationBar}></Route>

            </Switch>
          </div>
        </Router >
      </ErrorBoundary>
    );
  }
}

export default LeftPanel;


// WEBPACK FOOTER //
// src/my-jeeva/LeftPanel.js